import {useCallback, useEffect, useRef, useState} from 'react';

const DELAI_PAR_DEFAUT_MS = 5000;

/**
 * Comme `useState<string | null>`, mais tout message non nul posé via le
 * setter disparaît automatiquement après `delaiMs` (un nouvel appel annule le
 * délai précédent ; `setMessage(null)` efface immédiatement sans attendre).
 */
export const useAutoDismissMessage = (
  delaiMs = DELAI_PAR_DEFAUT_MS
): [string | null, (message: string | null) => void] => {
  const [message, setMessageState] = useState<string | null>(null);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(
    () => () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    },
    []
  );

  const setMessage = useCallback(
    (nouveauMessage: string | null): void => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      setMessageState(nouveauMessage);
      if (nouveauMessage !== null) {
        timeoutRef.current = setTimeout(() => setMessageState(null), delaiMs);
      }
    },
    [delaiMs]
  );

  return [message, setMessage];
};
